import { useState } from 'react';
import { MapViewportFilterContext } from '../context/map-viewport-filter';

/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @returns {React.JSX.Element}
 */
export const MapViewportFilterProvider = ({ children }) => {
  const [mapViewportFilter, setMapViewportFilter] = useState({
    disabled: false,
  });

  return (
    <MapViewportFilterContext.Provider value={{ mapViewportFilter, setMapViewportFilter }}>
      {children}
    </MapViewportFilterContext.Provider>
  );
};
